import { apiClient } from "@/shared/api/client";
import type { SupportChatIdentity } from "../types";

/**
 * Identité signée par le serveur pour le Secure Mode tawk.to.
 *
 * Le navigateur ne calcule jamais le HMAC : la clé de propriété tawk.to est un
 * secret serveur et ne doit apparaître dans aucune variable VITE_*.
 */
export async function getSupportChatIdentity(): Promise<SupportChatIdentity> {
  const { data } = await apiClient.get<SupportChatIdentity>("/support/chat/identity", {
    headers: { "Cache-Control": "no-store" },
  });
  return data;
}

